import React from 'react';
import { IFrameStyles } from '../../assessment/styles';

/** A Blank page for intial load and redirection */
export const SplashPage = (): JSX.Element => {
  const classes = IFrameStyles();

  React.useLayoutEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    const initialClass = body.className;
    body.className = `notranslate ${classes.container}`;

    return (): void => {
      body.className = initialClass;
    };
  }, [classes.container]);
  return <></>;
};
